import { create } from 'zustand';

export const useWaiterTable = create((set) => ({
  products: [],

  addTable: (table) => set(() => ({ table })),
  addProductToRequest: (product) =>
    set(({ products }) => ({ products: [...products, product] })),
  updateProduct: (amount, index) =>
    set(({ products }) => {
      const updatedProducts = products.map((product, i) => {
        if (index === i) {
          return {
            ...product,
            cart: {
              ...product.cart,
              amount,
            },
          };
        }

        return product;
      });

      return { products: updatedProducts };
    }),
  removeProduct: (index) =>
    set(({ products }) => {
      const updatedProducts = products.filter((_, i) => i !== index);

      return { products: updatedProducts };
    }),
  reset: () => set(() => ({ products: [] })),
}));
